










































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ProductCollectionItemPublic } from '@cms-labs/typescript-api/products/types'

import AddToCartButton from '@/components/AddToCartButton.vue'
import { BRow, BCol, BCard, BCardBody, BBadge } from 'bootstrap-vue'

@Component({
  components: { BRow, BCol, BCard, BCardBody, AddToCartButton, BBadge }
})
export default class TopProducts extends Vue {
  @Prop({ required: true })
  private product!: ProductCollectionItemPublic

  private productPriceReg = Math.round(
    (this.product.price) / (1 - this.product.discount_pct / 100)
  )
}
